// Jquery validation extends
var defaultRangeValidator = $.validator.methods.range;
$.validator.methods.range = function(value, element, param) {
    if (element.type === "checkbox") {
        return element.checked;
    } else {
        return defaultRangeValidator.call(this, value, element, param);
    }
};

$.validator.setDefaults({
    highlight: function(element, errorClass, validClass) {
        // default function
        if (element.type === "radio") {
            this.findByName(element.name)
                .addClass(errorClass)
                .removeClass(validClass);
        } else {
            $(element)
                .addClass(errorClass)
                .removeClass(validClass);
        }
        // custom additions
        $(element)
            .closest("div.form-group")
            .addClass("has-error");
    },
    unhighlight: function(element, errorClass, validClass) {
        // default function
        if (element.type === "radio") {
            this.findByName(element.name)
                .removeClass(errorClass)
                .addClass(validClass);
        } else {
            $(element)
                .removeClass(errorClass)
                .addClass(validClass);
        }
        // custom additions
        $(element)
            .closest("div.form-group")
            .removeClass("has-error");
    }
});

$.validator.messages.email = "Email formatı hatalı.";
